import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Zap } from "lucide-react";

export function FanLevelBadge({ userId, compact = false }) {
  const { api } = useAuth();
  const [level, setLevel] = useState(null);

  useEffect(() => {
    const url = userId ? `/badges/level/${userId}` : "/badges/level";
    api.get(url)
      .then((res) => setLevel(res.data))
      .catch(console.error);
  }, [api, userId]);

  if (!level) return null;

  if (compact) {
    return (
      <span
        className="inline-flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full"
        style={{ backgroundColor: `${level.color}20`, color: level.color }}
        data-testid="fan-level-badge-compact"
      >
        <Zap className="w-2.5 h-2.5" />
        Nv.{level.level}
      </span>
    );
  }

  return (
    <div className="bg-card border border-border rounded-3xl p-5 shadow-sm" data-testid="fan-level-section">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ backgroundColor: `${level.color}20` }}
          >
            <Zap className="w-4 h-4" style={{ color: level.color }} />
          </div>
          <div>
            <p className="font-heading font-bold text-sm text-card-foreground">{level.name}</p>
            <p className="text-[10px] text-muted-foreground">Niveau {level.level} &middot; {level.xp} XP</p>
          </div>
        </div>
        {level.next_level && (
          <div className="text-right">
            <p className="text-[10px] text-muted-foreground">Prochain</p>
            <p className="text-xs font-bold" style={{ color: level.next_level.color }}>
              {level.next_level.name}
            </p>
          </div>
        )}
      </div>
      {level.next_level && (
        <div className="w-full bg-border rounded-full h-2 overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${Math.min(100, level.progress_to_next * 100)}%`,
              backgroundColor: level.color,
            }}
          />
        </div>
      )}
      {level.next_level && (
        <p className="text-[10px] text-muted-foreground mt-1.5 text-center">
          {level.next_level.min_xp - level.xp} XP restants pour {level.next_level.name}
        </p>
      )}
    </div>
  );
}
